import ApplicationSerializer from 'eflex/serializers/application';

export default class CameraStatusSerializer extends ApplicationSerializer {
  attrs = {
    lastImage: {
      embedded: 'always',
    },
  };
}
